import "./AddGbModal.scss";
import { useSetZIndex } from "../../../../../../../../../../hooks/useSetZIndex";
import { CustomModal } from "../../../../../../../../../../components/ui/CustomModal/CustomModal";
import { TariffCard } from "../TariffCard/TariffCard";
import { CustomSelect } from "../../../../../../../../../../components/ui/CustomSelect/CustomSelect";
import { CheckBox } from "../../../../../../../../../../components/ui/CheckBoxes/CheckBox";
import { Button } from "../../../../../../../../../../components/ui/Buttons/Button/Button";
import { useTranslation } from "../../../../../../../../../../hooks";

export const AddGbModal = () => {
  useSetZIndex(".cabinet", "999");

  const { cabinet: { orders: { residential: {
    addGbTitle, selectTariff, selectPayment, cancel,
    paymentMethodPlaceholder, setPermanent, order
  } } } } = useTranslation();

  return (
    <CustomModal
      open={true}
      styles={{ zIndex: "999999999" }}
    >
      <div className="add-gb-modal">
        <div className="add-gb-modal__title">{addGbTitle}</div>
        <div className="add-gb-modal__container">
          <div className="add-gb-modal__label add-gb-modal__label--tariff">{selectTariff}</div>
          <div className="add-gb-modal__tariffs">
            <TariffCard />
            <TariffCard />
            <TariffCard />
            <TariffCard />
            <TariffCard />
            <TariffCard />
          </div>
        </div>
        <div className="add-gb-modal__container">
          <div className="add-gb-modal__label">{selectPayment}</div>
          <CustomSelect placeholder={paymentMethodPlaceholder} />
        </div>
        <CheckBox label={setPermanent} />
        <div className="add-gb-modal__actions">
          <Button>{cancel}</Button>
          <Button tab="confirm">{order}</Button>
        </div>
      </div>
    </CustomModal>
  );
};
